import(/* webpackMode: "eager", webpackExports: ["AppInitializerWithTanstack"] */ "/workspace/app/components/AppInitializerWithTanstack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopilotPanel"] */ "/workspace/app/components/CopilotPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/app/components/DismissableToaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/app/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutWrapper"] */ "/workspace/app/components/LayoutWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimpleTooltipProvider"] */ "/workspace/app/components/ui/simple-tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/workspace/app/lib/providers.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/app/styles/editor.css");
